import { GridColDef } from "@mui/x-data-grid-pro";

// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

const columns: GridColDef[] = [
	{
		field: "_id",
		headerName: "ID",
		flex: 1,
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },
	{
		headerName: "",
		field: "manuallyReconciled",
		editable: true,
	},
	{
		headerName: "Lot/Address",
		field: "name",
		width: 100,
	},
	{
		headerName: "VIN",
		field: "vinNumber",
		width: 120,
	},
	{
		headerName: "Year",
		field: "year",
		width: 120,
	},
	{
		headerName: "Make",
		field: "make",
		width: 140,
	},
	{
		headerName: "Model",
		field: "model",
		width: 140,
	},
	{
		headerName: "Color",
		field: "color",
		width: 110,
	},
	{
		headerName: "Reason",
		field: "reason",
		width: 140,
		editable: true,
	},
	{
		headerName: "Resolution",
		field: "resolution",
		width: 140,
		editable: true,
	},
	{
		headerName: "Notes",
		field: "notes",
		headerAlign: "right",
		align: "right",
		width: 80,
		editable: true,
	},
];

type TOnLotNotOnMfgTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

export default function OnLotNotOnMfgTable(props: TOnLotNotOnMfgTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onLotNotOnMfg"
		/>
	);
}
